import Api from 'api/api';

class CategoryApi {
    listCategories() {
        return Api.get('/categories');
    }

    listHidden() {
        return Api.get('/categories/hidden');
    }

    create({name, category}) {
        return Api.post('/categories', {name, category});
    }

    edit(categoryId, {name}) {
        return Api.put(`/categories/${categoryId}`, {name});
    }

    hide(categoryId) {
        return Api.patch(`/categories/${categoryId}/hide`);
    }

    unhide(categoryId) {
        return Api.patch(`/categories/${categoryId}/unhide`);
    }

    delete(categoryId) {
        return Api.delete(`/categories/${categoryId}`);
    }
}

export default new CategoryApi();


// WEBPACK FOOTER //
// ./src/api/category.js